import React, { useEffect, useState } from 'react';
import { AgChartsReact } from 'ag-charts-react';

const LineChart = ({ data = [], _range = [], type }) => { 

    
    const formatDate = (yyyymmdd) => {
        if(yyyymmdd) {
            const year = yyyymmdd.slice(2, 4);
            const month = yyyymmdd.slice(4, 6);
            const day = yyyymmdd.slice(6, 8);
            return `${year}.${month}.${day}`;
        } else {
            return '';
        }
    };

    
    useEffect(() => {
        if (!data || !Array.isArray(data)) {
            return;
        }

        let formattedData;

        if (type === 'bloodPressure') {
            formattedData = data.map(item => ({
                category: item.prscrptnTestRsltDate,
                top: Number(item.brssrTop),
                low: Number(item.brssrLwet),
                unit: item.unit,
            }));
        } else {
            formattedData = data.map(item => ({
                category: item.prscrptnTestRsltDate,
                value: Number(item.prscrptnTestRsltVal),
                unit: item.unit,
            }));
        }

        const values =
            type === 'bloodPressure'
                ? formattedData.flatMap(d => [d.top, d.low])
                : formattedData.map(d => d.value);

        if (_range.length === 2) {
            const minValue = Math.min(_range[0], ...values);
            const maxValue = Math.max(_range[1], ...values);
            const margin = (maxValue - minValue) * 0.1;

            const minY = minValue - margin;
            const maxY = maxValue + margin;

            const isBloodPressure = type === 'bloodPressure';

            // 이완기 라벨을 마커 아래로 내리기 위한 오프셋 (혈압 전용)
            const LABEL_GAP_RATIO = 0.35;
            const labelOffset = isBloodPressure
                ? (maxY - minY) * (LABEL_GAP_RATIO / (1 - LABEL_GAP_RATIO))
                : 0;

            /*
            * gridLine.style은 tick 오름차순으로 매칭된다.
            * 하한(_range[0]) → 빨강, 상한(_range[1]) → 초록
            */
            const isAscending = Number(_range[0]) <= Number(_range[1]);

            const sortedRange = isAscending
                ? [Number(_range[0]), Number(_range[1])]
                : [Number(_range[1]), Number(_range[0])];

            const gridLineStyle = isAscending
                ? [
                    { stroke: '#E55151', lineDash: [] },   // 하한
                    { stroke: '#46AF83', lineDash: [] },   // 상한
                ]
                : [
                    { stroke: '#46AF83', lineDash: [] },
                    { stroke: '#E55151', lineDash: [] },
                ];

            setOption(prev => ({
                ...prev,
                // data: formattedData,
                data: isBloodPressure
                    ? formattedData.map(d => ({ ...d, lowLabel: d.low - labelOffset }))
                    : formattedData,
                series:
                    isBloodPressure
                        ? [
                            {
                                xKey: 'category',
                                yKey: 'top',
                                yName: '수축기',
                                type: 'line',
                                strokeWidth: 4,
                                stroke: "#1065D9",
                                label: {
                                    fontSize: 11,
                                    color: '#82868C',
                                    fontWeight: 'bold',
                                    enabled: true,
                                    // formatter: ({ params }) =>
                                    // `${params.datum.value}`,
                                    formatter: ({ datum }) => `${datum.top}`,
                                },
                                marker: {
                                    fill: "#ffffff",
                                    size: 10,
                                    strokeWidth: 1.5,
                                    stroke : "#1065D9",
                                },
                                tooltip: {
                                    enabled: false,
                                },
                            },
                            {
                                xKey: 'category',
                                yKey: 'low',
                                yName: '이완기',
                                type: 'line',
                                strokeWidth: 4,
                                stroke: "#00A1A9",
                                label: {
                                    // fontSize: 11,
                                    // color: '#82868C',
                                    // fontWeight: 'bold',
                                    // placement: 'below',
                                    // enabled: true,
                                    // formatter: ({ params }) =>
                                    // `${params.datum.value}`,
                                    // formatter: ({ datum }) => `${datum.low}`,
                                    enabled: false,
                                },
                                marker: {
                                    fill: "#ffffff",
                                    size: 10,
                                    strokeWidth: 1.5,
                                    stroke : "#00A1A9",
                                },
                                tooltip: {
                                    enabled: false,
                                },
                            },
                            // 라벨 전용 유령 시리즈 — 선/마커 없이 텍스트만 아래에 렌더
                            {
                                xKey: 'category',
                                yKey: 'lowLabel',
                                yName: '이완기라벨',
                                type: 'line',
                                stroke: 'transparent',
                                strokeWidth: 0,
                                showInLegend: false,
                                marker: { enabled: false },
                                tooltip: { enabled: false },
                                label: {
                                    fontSize: 11,
                                    color: '#82868C',
                                    fontWeight: 'bold',
                                    enabled: true,
                                    formatter: ({ datum }) => `${datum.low}`,
                                },
                            },
                        ]
                        : prev.series,
                axes: [
                    prev.axes[0],
                    {
                        ...prev.axes[1],
                        min: minY - labelOffset,
                        max: maxY,
                        visible: true,
                        tick: {
                            values: sortedRange,
                            size: 0,
                        },
                        label: {
                            enabled: true,
                            fontSize: 11,
                            fontFamily: 'Pretendard',
                            color: '#A2A6AC',
                            formatter: ({ value }) => `${value}`,
                        },
                        gridLine: {
                            enabled: true,
                            style: gridLineStyle,
                        },
                    },
                ],
            }));
        } else {
            setOption(prev => ({
                ...prev,
                data: formattedData,
            }));
        }
    }, [data, type, _range[0], _range[1]]);

    // const tooltipRenderer = (params) => {
        
    //     const color = params.datum.value < _range[0] || params.datum.value > _range[1] ? "red" : "#248F79";

    //     return (
    //         '<div class="ag-chart-tooltip-title" style="background-color: ' +
    //         color +
    //         '">' +
    //         params.datum.value + ' ' + params.datum.unit +
    //         '</div>' 
    //     );
    // }

    const [options, setOption] = useState({
        autoSize: true,
        data: [],
        background: {
             fill: 'transparent',   // 컨테이너(#F4F6FA)가 비치도록
         },
        series: [{
            xKey: 'category', 
            yKey: 'value', 
            type: 'line', 
            strokeWidth: 4,
            stroke: "#1065D9",
            label: {
                fontSize: 11,
                color: '#82868C',
                fontWeight: 'bold',
                enabled: true,
                // formatter: ({ params }) =>
                //   `${params.datum.value}`,
                formatter: ({ datum }) => `${datum.value}`,
              },
            marker: {
                fill: "#ffffff",
                size: 10,
                strokeWidth: 1.5,
                stroke : "#1065D9",
                },
            tooltip: {
                enabled: false
            }
        }],
        axes: [
        {
            type: 'category',
            position: 'bottom',
            reverse: true,
            label: {
                fontSize: 9,
                fontFamily: 'Pretendard',
                fontWeight: '500',
                color: '#82868C',
                formatter: ({ value }) => `${formatDate(value)}\n`,
            },
            line: {
                enabled: false,
            },
            gridLine: {
                enabled: false,
            },
            visible: true,
        }, 
        {
            type: 'number',
            position: 'left',
            nice: false, 
            label: {
                enabled: false, 
            },
            line: {
                enabled: false,
            },
            gridLine: {
                enabled: false,
            },
            visible: false, // Y축 숨기기
            // crossLines: [
            //     {
            //       type: 'line',
            //       value: _range[0],
            //       stroke: '#E55151',
            //       strokeWidth: 1,
            //     //   zIndex: -1,
            //       layer: 'background',
            //       label: {
            //         text: _range[0] + '',
            //         fontSize: 12,
            //         color: '#A2A6AC',
            //         position: 'left',
            //       },
            //     },
            //     {
            //       type: 'line',
            //       value: _range[1],
            //       stroke: '#46AF83',
            //       strokeWidth: 1,
            //       //   zIndex: -1,
            //       layer: 'background',
            //       label: {
            //         text: _range[1] + '',
            //         fontSize: 11,
            //         color: '#A2A6AC',
            //         position: 'left',
            //       },
            //     },
            // ],
        }]
    });

    // return (
    //     <AgChartsReact options={options} />
    // );
    return (
        <>
            {options.data.length > 0 ? (
                <AgChartsReact options={options} />
            ) : (
                <AgChartsReact options={{ 
                    ...options, 
                    data: [],                     
                    series: options.series,
                    axes: options.axes,
                    noData: { text: '' }, 
                }} />
            )}
        </>
    );
    
};

export default LineChart;
